import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

import { format } from 'date-fns';

const WasteRecyclable = ({ years, months, wasteTypes, getYears, yearTitles, wasteTotals }) => {
  if (!wasteTypes && !wasteTotals) return null;

  if (months.length > 0 || getYears.length > 0) {
    return (
      <div style={{ overflow: 'auto' }}>
        <h3>Waste by Type</h3>
        <table className='app-table' style={{ textAlign: 'right' }}>
          <thead className='bg-muted'>
            <tr>
              <th width='20%' className='text-muted-foreground font-semibold'> Waste Type </th>

              {['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'].map((month) => {
                return (
                  <>
                    {getYears.map((year) => {
                      return (
                        <th
                          className={`toggle-absolute toggle-year-${year} toggle-month-${month} text-muted-foreground font-semibold`}
                          width='15%'
                          style={{ textAlign: 'right' }}>
                          {format(new Date(year, month - 1), 'MMM yy')}
                        </th>
                      );
                    })}
                  </>
                );
              })}
            </tr>
          </thead>

          <tbody>
            {wasteTotals &&
              Object.keys(wasteTotals).map((wasteType) => {
                return (
                  <tr>
                    <td style={{ textAlign: 'left' }}>{wasteType}</td>
                    {['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'].map((month) => {
                      return getYears.map((year) => {
                        return (
                          <td
                            className={`toggle-year-${year} toggle-month-${month}`}
                            width='15%'
                            style={{ textAlign: 'right' }}>
                            {(wasteTotals[wasteType][`${year}-${month}`] &&
                              wasteTotals[wasteType][`${year}-${month}`].toFixed(3)) ||
                              0}
                          </td>
                        );
                      });
                    })}
                  </tr>
                );
              })}

            <tr>
              <td style={{ textAlign: 'left', width: '10%' }}>% Recycled</td>
              {['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'].map((month) => {
                const recycled =
                  wasteTotals &&
                  _.sumBy(Object.keys(wasteTotals), (wasteType) => {
                    const isRecycled =
                      wasteTypes &&
                      wasteTypes.find((item) => item?.recyclable) &&
                      wasteTypes.find((item) => wasteType === item?.recyclingType).recyclable === 1;
                    return isRecycled
                      ? parseFloat((wasteTotals[wasteType][month] && wasteTotals[wasteType][month].toFixed(3)) || 0)
                      : 0;
                  });
                const all =
                  wasteTotals &&
                  _.sumBy(Object.keys(wasteTotals), (wasteType) => {
                    return parseFloat((wasteTotals[wasteType][month] && wasteTotals[wasteType][month].toFixed(3)) || 0);
                  });
                const percentage = all ? ((recycled / all) * 100).toFixed(3) : 'N/A';

                return getYears.map((year) => {
                  return (
                    <td className={`toggle-year-${year} toggle-month-${month}`} width='15%' style={{ textAlign: 'right' }}>
                      {percentage}
                      {!isNaN(percentage) && `%`}
                    </td>
                  );
                });
              })}
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className='my-8'>
      <h3 className='text-lg font-semibold mb-4 text-foreground'>Waste by Type</h3>
      <div className='overflow-x-auto rounded shadow'>
        <table className='min-w-full bg-card text-card-foreground border border-border' style={{ textAlign: 'right' }}>
          <thead className='bg-muted'>
            <tr>
              <th width='20%' className='text-muted-foreground font-semibold text-left p-[10px]'>Waste Type</th>

              {years.map((year, index) => (
                <th
                  key={crypto.randomUUID()}
                  className={`toggle-absolute toggle-year-${year} ${index > 1 ? 'hidden sm:table-cell' : ''} text-muted-foreground font-semibold p-[10px]`}
                  width='15%'
                  style={{ textAlign: 'right' }}>
                  {yearTitles[year]}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {wasteTotals &&
              Object.keys(wasteTotals).map((wasteType) => {
                return (
                  <tr className={`${wasteType}-row`} key={crypto.randomUUID()}>
                    <td className='text-left px-[10px]'>{wasteType}</td>
                    {years.map((year, index) => {
                      return (
                        <td
                          key={crypto.randomUUID()}
                          className={`toggle-year-${year} ${index > 1 ? 'hidden sm:table-cell' : ''} px-[10px]`}
                          width='15%'
                          style={{ textAlign: 'right' }}>
                          {wasteTotals?.[wasteType]?.[year]?.toFixed(3) || 0}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}

            <tr className='recycled-row'>
              <td className='text-left px-[10px]'>% Recycled</td>
              {years.map((year, index) => {
                const recycled = _.sumBy(Object.keys(wasteTotals), (wasteType) => {
                  const isRecycled =
                    wasteTypes &&
                    wasteTypes.find((item) => item?.recyclable) &&
                    wasteTypes.find((item) => wasteType === item?.recyclingType)?.recyclable === 1;

                  return isRecycled
                    ? parseFloat((wasteTotals[wasteType][year] && wasteTotals[wasteType][year].toFixed(3)) || 0)
                    : 0;
                });

                const all = _.sumBy(Object.keys(wasteTotals), (wasteType) => {
                  return parseFloat((wasteTotals[wasteType][year] && wasteTotals[wasteType][year].toFixed(3)) || 0);
                });

                const percentage = all ? ((recycled / all) * 100).toFixed(3) : 'N/A';

                return (
                  <td
                    key={crypto.randomUUID()}
                    className={`toggle-year-${year} ${index > 1 ? 'hidden sm:table-cell' : ''} px-[10px]`}
                    width='15%'
                    style={{ textAlign: 'right' }}>
                    {percentage}
                    {!isNaN(percentage) && `%`}
                  </td>
                );
              })}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  const { getYears } = ownProps;
  const currentOrganisation = state?.currentOrganisation;
  const { years, months } = state.consumption || {};
  const report = state?.report?.details;
  const includedOrgs = [currentOrganisation, ...state?.report?.includedOrgs];

  const yearTitles = {};
  years?.forEach((y) => {
    yearTitles[y] = report?.startDate?.split('-')[0] !== report?.endDate?.split('-')[0] ? y - 1 + ' - ' + y : y;
  });

  const wasteTotals = {};
  includedOrgs?.forEach((org) => {
    //add the waste types of all the organisations together into 1 object having properties of each waste type and % recycled
    const wasteByType = state?.consumption?.wasteByType?.[org];
    if (!wasteByType) return;
    Object?.keys(wasteByType)?.forEach((wasteType) => {
      if (!wasteTotals[wasteType]) {
        wasteTotals[wasteType] = {};
      }
      Object?.keys(wasteByType[wasteType])?.forEach((yearMonth) => {
        if (!wasteTotals[wasteType][yearMonth]) {
          wasteTotals[wasteType][yearMonth] = 0;
        }
        wasteTotals[wasteType][yearMonth] += wasteByType[wasteType][yearMonth];
      });
    });
  });

  return {
    wasteTypes: state?.metric?.types?.waste,
    years: years || [],
    months: months || [],
    getYears: getYears || [],
    yearTitles,
    currentOrganisation,
    includedOrgs,
    wasteTotals,
  };
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(WasteRecyclable);
